import React from 'react';
import {Input} from "antd"
import useMortgage from "../../../../../../../../../providers/mortgage/useMortgage";
function ReasonForAdvisorReview({uploadId}) {
    const mortgage = useMortgage()
    const upload = mortgage.uploads.find(item => item.id === uploadId);
    const [busy, setBusy] = React.useState(false)
    const handleBlur = async (e) => {
        const reason = e.target.value
        setBusy(true)
        await mortgage.mutate({
            update: {
                target: `uploads[${uploadId}].advisorAlert`,
                value: reason
            }
        })
        setBusy(false)
    }

    const reason = upload.advisorAlert || ''

    return (
       <Input.TextArea disabled={busy} onBlur={handleBlur} autoSize placeholder="Reason for Advisor Review" defaultValue={reason}/>
    );
}

export default ReasonForAdvisorReview;